const defaultSize = 24;
const defaultStrokeWidth = 2;

export const zIndexMap = Object.freeze( {
	stopped: 2,
	direction: 3,
	scheduleDelivery: 4,
	schedulePickup: 4,
	scheduleReturn: 4,
	problem: 5,
	store: 6,
	start: 7,
	end: 8
} );

export const store = Object.freeze( {
	size: defaultSize,
	strokeWidth: defaultStrokeWidth,
	content: '<polygon points="1.214,5.1 7.7,3.844 7.7,9.194 12.9,2.835 21.8,1.1 12.877,11.853 22.258,19 14,20.634 7.7,15.767 7.7,21.854 1.2,23.1"/><polygon fill="none" stroke="#808284" stroke-width="0.7" stroke-miterlimit="10" points="0.864,4.813 8.044,3.4 8.044,8.214 12.715,2.516 22.693,0.581 13.379,11.796 23.089,19.226 13.9,21 8.044,16.479 8.044,22.143 0.864,23.535"/><polygon fill="#FFFFFF" stroke="#DE2027" stroke-width="0.6" stroke-miterlimit="10" points="2.748,6.352 2.748,21.263 6.2,20.596 6.2,14.224 7.8,13.9 14.374,19 18.668,18.179 10.7,12.1 17.934,3.4 13.729,4.225 7.782,11.479 6.2,11.787 6.2,5.684"/>'
} );

export const direction = Object.freeze( {
	size: defaultSize,
	strokeWidth: defaultStrokeWidth,
	get content() {
		return `<circle fill="#42A5F5" stroke="#1E88E5" stroke-width="${this.strokeWidth}" cx="${this.size / 2}" cy="${this.size / 2}" r="${( this.size / 2 ) - ( this.strokeWidth / 2 )}"/><polygon fill="#0D47A1" points="12,4 5,18 12,15 19,18"/>`;
	}
} );

export const directionSmall = Object.freeze( {
	size: 18,
	strokeWidth: defaultStrokeWidth,
	get content() {
		const topPoint = `${this.size / 2},${this.strokeWidth}`;
		const bottomRightPoint = `${this.size - this.strokeWidth},${this.size - this.strokeWidth}`;
		const middlePoint = `${this.size / 2},${this.size * 3 / 4}`;
		const bottomLeftPoint = `${this.strokeWidth},${this.size - this.strokeWidth}`;

		return `<polygon fill="#81D4FA" stroke="#0277BD" stroke-width="${this.strokeWidth}" points="${topPoint} ${bottomRightPoint} ${middlePoint} ${bottomLeftPoint}"/>`;
	}
} );

export const start = Object.freeze( {
	size: defaultSize,
	strokeWidth: defaultStrokeWidth,
	get content() {
		return `<circle fill="#424242" stroke="#212121" stroke-width="${this.strokeWidth}" cx="${this.size / 2}" cy="${this.size / 2}" r="${( this.size / 2 ) - ( this.strokeWidth / 2 )}"/><text transform="translate(7, 17)" fill="#FFF" font-family="Verdana" font-size="16">S</text>`;
	}
} );

export const end = Object.freeze( {
	size: defaultSize,
	strokeWidth: defaultStrokeWidth,
	get content() {
		return `<circle fill="#424242" stroke="#212121" stroke-width="${this.strokeWidth}" cx="${this.size / 2}" cy="${this.size / 2}" r="${( this.size / 2 ) - ( this.strokeWidth / 2 )}"/><text transform="translate(7, 17)" fill="#FFF" font-family="Verdana" font-size="16">E</text>`;
	}
} );

export const problem = Object.freeze( {
	size: defaultSize,
	strokeWidth: defaultStrokeWidth,
	get content() {
		return `<circle fill="#EF5350" stroke="#C62828" stroke-width="${this.strokeWidth}" cx="${this.size / 2}" cy="${this.size / 2}" r="${( this.size / 2 ) - ( this.strokeWidth / 2 )}"/><path fill="#FFFFFF" d="M12.091,19.34c-0.546,0-0.997-0.166-1.352-0.498c-0.355-0.331-0.532-0.733-0.532-1.205 c0-0.492,0.179-0.896,0.538-1.21s0.807-0.472,1.346-0.472c0.547,0,0.994,0.159,1.342,0.477c0.349,0.318,0.522,0.72,0.522,1.205 c0,0.492-0.173,0.899-0.518,1.221S12.645,19.34,12.091,19.34z M13.771,4.397l-0.399,10.132H10.75L10.371,4.397H13.771z"/>`;
	}
} );

export const stopped = Object.freeze( {
	size: defaultSize,
	strokeWidth: defaultStrokeWidth,
	get content() {
		return `<circle fill="#EF5350" stroke="#C62828" stroke-width="${this.strokeWidth}" cx="${this.size / 2}" cy="${this.size / 2}" r="${( this.size / 2 ) - ( this.strokeWidth / 2 )}"/><rect x="${this.size / 3}" y="${this.size / 3}" fill="#FFF" width="${this.size / 3}" height="${this.size / 3}"/>`;
	}
} );

export const softStop = Object.freeze( {
	size: defaultSize,
	strokeWidth: defaultStrokeWidth,
	get content() {
		return `<rect fill="#FFB300" stroke="#FF6F00" stroke-width="${this.strokeWidth}" x="${this.size / 4}" y="${this.size / 4}" width="${this.size / 2}" height="${this.size / 2}"/>`;
	}
} );

export const hardStop = Object.freeze( {
	size: defaultSize,
	strokeWidth: defaultStrokeWidth,
	get content() {
		return `<rect fill="#E53935" stroke="#B71C1C" stroke-width="${this.strokeWidth}" x="${this.size / 4}" y="${this.size / 4}" width="${this.size / 2}" height="${this.size / 2}"/>`;
	}
} );

export const textMarker = ( text, fillColor, strokeColor, size ) => ( {
	size,
	get strokeWidth() {
		return Math.floor( this.size / 9 );
	},
	get iconText() {
		return text.slice( 0, 1 ).toUpperCase();
	},
	get content() {
		const midpoint = this.size / 2;

		return `<circle fill="${fillColor}" stroke="${strokeColor}" stroke-width="${this.strokeWidth}" cx="${midpoint}" cy="${midpoint}" r="${midpoint - ( this.strokeWidth / 2 )}"/><text x="${midpoint}" y="${midpoint}" alignment-baseline="central" text-anchor="middle" fill="${strokeColor}" font-family="Arial, Helvetica, sans-serif" font-weight="bold" font-size="${Math.floor( this.size * 0.8 )}">${this.iconText}</text>`;
	}
} );

export const service = ( fillColor, strokeColor, size ) => ( {
	size,
	get strokeWidth() {
		return Math.floor( this.size / 7 );
	},
	get content() {
		return `<circle fill="${fillColor}" stroke="${strokeColor}" stroke-width="${this.strokeWidth}" cx="${this.size / 2}" cy="${this.size / 2}" r="${( this.size / 2 ) - ( this.strokeWidth / 2 )}"/>`;
	}
} );

export const serviceCluster = ( fillColor, strokeColor, size ) => ( {
	size,
	get strokeWidth() {
		return Math.floor( this.size / 5 );
	},
	get content() {
		return `<circle fill="${fillColor}" stroke="${strokeColor}" stroke-width="${this.strokeWidth}" cx="${this.size / 2}" cy="${this.size / 2}" r="${( this.size / 2 ) - ( this.strokeWidth / 2 )}"/>`;
	}
} );

export function rotateMarker( icon, rotation ) {
	const iconCopy = Object.assign( {}, icon );

	iconCopy.content = `<g transform="rotate(${rotation} ${iconCopy.size / 2} ${iconCopy.size / 2})">${iconCopy.content}</g>`;

	return iconCopy;
}

export function encodeMarker( icon ) {
	const iconCopy = Object.assign( {}, icon );
	const iconSize = iconCopy.size;

	iconCopy.content = encodeURIComponent( `<svg xmlns="http://www.w3.org/2000/svg" width="${iconSize}px" height="${iconSize}px" viewBox="0 0 ${iconSize} ${iconSize}">${iconCopy.content}</svg>` );

	iconCopy.content = `data:image/svg+xml;charset=UTF-8,${iconCopy.content}`;

	return iconCopy;
}

export function genGoogleIcon( google, icon ) {
	if ( google && icon ) {
		const iconSize = new google.maps.Size( icon.size, icon.size );

		return {
			anchor: new google.maps.Point( icon.size / 2, icon.size / 2 ),
			url: encodeMarker( icon ).content,
			scaledSize: iconSize,
			size: iconSize
		};
	}
}
